export default __webpack_public_path__ + "static/media/img5.a7a05ccb.jpeg";